import keyMirror from './keyMirror';

export default keyMirror('pending', 'fulfilled', 'rejected');
